import React, { useContext, useState } from 'react';
import { AppContext } from '../context/AppContext';
import AnggotaForm from './AnggotaForm';

const AnggotaList = () => {
  const { anggota, hapusAnggota } = useContext(AppContext);
  const [editing, setEditing] = useState(null);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Daftar Anggota</h2>
      <AnggotaForm onSaveComplete={() => {}} />
      <div className="mt-4">
        {anggota.length === 0 && <p className="text-gray-500">Belum ada anggota. Silakan tambah.</p>}
        {anggota.map(angg => (
          <div key={angg.id} className="border p-3 mb-2 rounded shadow flex justify-between items-center">
            <div>
              <p><strong>{angg.nama}</strong> - Jumlah Anak: {angg.jumlah_anak}</p>
              {angg.pendapatan && <p className="text-sm text-gray-500">Estimasi Pendapatan: Rp {angg.pendapatan.toLocaleString()}</p>}
            </div>
            <div>
              <button onClick={() => setEditing(angg)} className="bg-yellow-500 text-white p-1 rounded mr-2">Edit</button>
              <button onClick={() => hapusAnggota(angg.id)} className="bg-red-500 text-white p-1 rounded">Hapus</button>
            </div>
          </div>
        ))}
      </div>
      {editing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-5 rounded shadow-lg w-96">
            <AnggotaForm initialData={editing} onCancel={() => setEditing(null)} onSaveComplete={() => setEditing(null)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AnggotaList;